<template>
    <section>
        <o-tabs>
            <o-tab-item label="Pictures" icon="images" variant="success" />
            <o-tab-item label="Music" icon="music" variant="info" />
            <o-tab-item label="Words" variant="warning" />
            <o-tab-item label="Videos" icon="video" variant="danger" />
        </o-tabs>
    </section>
</template>
